import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import { libs, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;
class EstelamResult extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.bgbirthdate1 = this.encodeSodurId(urlParams[0]);
        this.bgbirthdate2 = this.encodeSodurId(urlParams[1]);
        this.bgbirthdate3 = this.encodeSodurId(urlParams[2]);
        this.bsbirthday4 = this.encodeSodurId(urlParams[3]);
        this.bsbirthday5 = this.encodeSodurId(urlParams[4]);
        this.bsbirthday6 = this.encodeSodurId(urlParams[5]);
        this.bimeshodebimegozar = this.encodeSodurId(urlParams[6]);
        this.diecapital = this.encodeSodurId(urlParams[7]);
        this.firstyearprm = this.encodeSodurId(urlParams[8]);
        this.paykind = this.encodeSodurId(urlParams[9]);
        this.pusheshfoot = this.encodeSodurId(urlParams[10]);
        this.pusheshamraz = this.encodeSodurId(urlParams[11]);
        this.pusheshpezeshki = this.encodeSodurId(urlParams[12]);
        this.pusheshnaghsozv = this.encodeSodurId(urlParams[13]);
        this.pusheshmoafiat = this.encodeSodurId(urlParams[14]);
        this.pusheshmostamari = this.encodeSodurId(urlParams[15]);
        this.dieCapitalchangezarib = this.encodeSodurId(urlParams[16]);
        this.firstyearprmzarib = this.encodeSodurId(urlParams[17]);
        this.firstyearprmcontainpusheshezafi = this.encodeSodurId(urlParams[18]);
        this.varizmotefareghe = this.encodeSodurId(urlParams[19]);

        if (this.bgbirthdate1 === "null" || this.bgbirthdate2 === "null" || this.bgbirthdate3 === "null") {
            this.bgbirthdate = ''
        }
        else {
            this.bgbirthdate = this.bgbirthdate1 + '/' + this.bgbirthdate2 + '/' + this.bgbirthdate3;
        }
        if (this.bsbirthday4 === "null" || this.bsbirthday5 === "null" || this.bsbirthday6 === "null") {
            this.bsbirthday = ''
        }
        else {
            this.bsbirthday = this.bsbirthday4 + '/' + this.bsbirthday5 + '/' + this.bsbirthday6;
        }
        this.modat = this.encodeSodurId(urlParams[20]);

        this.state = {
            isloading: true,
            activeTab: 1,
            data: {},

        }
        this.state.data = {};
        this.loadDetail();

    }

    encodeSodurId(encodedId) {
        return encodedId;
    }


    loadDetail() {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/lf/api/lf/CalcInquery",

                {
                    bgBirthday: this.bgbirthdate, bsBirthday: this.bsbirthday, bimeShodeIsBimegozar: this.bimeshodebimegozar, dieCapital: this.diecapital, firstYearPrm: this.firstyearprm, payKind: this.paykind, pusheshFot: this.pusheshfoot, pusheshAmraz: this.pusheshamraz, pusheshPezeshki: this.pusheshpezeshki,
                    pusheshNaghsOzv: this.pusheshnaghsozv, pusheshMoafiat: this.pusheshmoafiat, pusheshMostamari: this.pusheshmostamari, dieCapitalChangeZarib: this.dieCapitalchangezarib, firstYearPrmChangeZarib: this.firstyearprmzarib, firstYearPrmContainsPusheshEzafi: this.firstyearprmcontainpusheshezafi, varizMotefareghe: this.varizmotefareghe,
                    moddat: this.modat
                }
            ),
            BimeManager.header())
            .then((result) => {
                // if(result.data.ErrorMessage ===''){
                console.log("result.data : ", JSON.stringify(result.data));
                this.setState({ data: result.data, isloading: false });
                  
                //}
                // else{
                //     alert(this.state.data.ErrorMessage)
                //     // PageManager.changePage(Config.p_estelam,[true]);
                // }

            })
            .catch((error) => { alert(error) })

    }


    render() {
        return (
            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>استعلام قیمت بیمه نامه</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({ activeTab: 1 }) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({ activeTab: 2 }) }}>
                            اطلاعات حق بیمه های سالانه
                        </NavLink>
                    </NavItem>
                </Nav>

                {!this.state.isloading ?
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId={1}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
{this.state.data.ErrorMessage===""?
                                        <Row>
                                            <Col sm="12" className="alignRight"><span className="bold-head">مدت بیمه نامه:</span>{this.state.data.Moddat}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">درصد افزایش حق بیمه:</span>{this.state.data.FirstYearPrmChangeZarib}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">اندوخته (واریز) متفرقه:</span>{this.state.data.VarizMotefaregheText}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">روش پرداخت حق بیمه:</span>{this.state.data.PayKindText}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">درصد افزایش سرمایه فوت:</span>{this.state.data.DieCapitalChangeZarib}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">منظور کردن پوشش ها درحق بیمه اولیه:</span>{this.state.data.FirstYearPrmContainsPusheshEzafiText}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">پوشش معافیت از پرداخت حق بیمه:</span>{this.state.data.SharhMoafiat}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">پوشش مستمری از کارافتادگی:</span>{this.state.data.SharhMostamari}</Col>

                                        </Row>:
                                         <Row>
                                         <Col sm="12" className="alignCenter"><span className="bold-head">{this.state.data.ErrorMessage}</span></Col>
                                         </Row>
                                    }
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={2}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.YearlyAmount) ? this.state.data.YearlyAmount.map((haghbime) => {
                                                    return <div className="border-List">

                                                        <Col sm="12"><span className="bold-head">سال بیمه ای:</span>{haghbime.Year}</Col>
                                                        <Col sm="12"><span className="bold-head">سن بیمه شده:</span>{haghbime.Age}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه فوت به هر علت:</span>{libs.StringFunctions.currancyPrint(haghbime.DieCapital) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">اندوخته تضمینی:</span>{libs.StringFunctions.currancyPrint(haghbime.AndokhteTazmini) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه فوت در اثر حادثه:</span>{libs.StringFunctions.currancyPrint(haghbime.SarmayeFotHadese) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه نقص عضو:</span>{libs.StringFunctions.currancyPrint(haghbime.SarmayeNaghseOzvHadese) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه هزینه های پزشکی:</span>{libs.StringFunctions.currancyPrint(haghbime.SarmayePezeshkiHadese) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه امراض خاص:</span>{libs.StringFunctions.currancyPrint(haghbime.CapitalAmalJarahi) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">ارزش بازخرید تضمینی:</span>{libs.StringFunctions.currancyPrint(haghbime.ArzeshBazKharid) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه پرداختی سال:</span>{libs.StringFunctions.currancyPrint(haghbime.HBPardakhtiSal) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">جمع حق بیمه پوشش های اضافی:</span>{libs.StringFunctions.currancyPrint(haghbime.HBPusheshEzafi) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">مبلغ قسط در هر سال:</span>{libs.StringFunctions.currancyPrint(haghbime.GhestYear) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه تجمعی:</span>{libs.StringFunctions.currancyPrint(haghbime.HBTajamoee) + ('ریال')}</Col>

                                                        <br />
                                                    </div>

                                                }) : 
                                                <div className="border-List">
                                                    <Col sm="12" className="alignCenter"><span className="bold-head">محتوایی برای این قسمت وجود ندارد</span></Col>
                                                </div>
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                    </TabContent> : (<ui.Preloader />)




                }
            </div>
        )

    }
}

export default EstelamResult;


// WEBPACK FOOTER //
// ./src/components/Inquiry/EstelamResult.js